import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { Fragment } from 'react';

const SkltnPerson = () => {

    const [arry, setArry] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9])

    return (
        <Fragment>
            <div className="InfoTitle">
                <span>اطلاعات شخصی</span>
            </div>
            <div className="personalInfo skltn">
                <div className="profilePic">
                    <Skeleton animation="wave" variant="rect" width={95} height={95} />
                </div>
                <div className="form">
                    <div className="inputs-form">
                        <div className="skltn-itme">
                            <Skeleton animation="wave" variant="rect" width={120} height={22} />
                            <Skeleton animation="wave" variant="rect" width={100 + '%'} height={38} />
                        </div>
                        <div className="skltn-itme">
                            <Skeleton animation="wave" variant="rect" width={120} height={22} />
                            <Skeleton animation="wave" variant="rect" width={100 + '%'} height={38} />
                        </div>
                        <div className="skltn-itme">
                            <Skeleton animation="wave" variant="rect" width={120} height={22} />
                            <Skeleton animation="wave" variant="rect" width={100 + '%'} height={38} />
                        </div>
                        <div className="skltn-itme">
                            <Skeleton animation="wave" variant="rect" width={120} height={22} />
                            <Skeleton animation="wave" variant="rect" width={100 + '%'} height={38} />
                        </div>
                        <div className="skltn-itme">
                            <Skeleton animation="wave" variant="rect" width={120} height={22} />
                            <Skeleton animation="wave" variant="rect" width={100 + '%'} height={38} />
                        </div>
                        <Skeleton animation="wave" variant="rect" width={180} height={38} />
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default SkltnPerson;
// <Skeleton animation="wave" variant="rect" width={32 + '%'} height={25} />